export enum DropdownItemTextEnum {
  editTags = 'Edit Tags',
  download = 'Download',
  delete = 'Delete',
  copyLink = 'Copy Evergreen Link',
  copyCurrentYearExpireableLink = 'Copy Current Year Expireable Link',
  copyNextYearExpireableLink = 'Copy Next Year Expireable Link',
  open = 'Open',
}
